module.exports = __webpack_public_path__ + "img/woman-icon.613c0223.svg";